/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { UpcomingPeriodicReviewTable } from './UpcomingPeriodicReviewTable'
import useDocumentsListService from '../../../../hooks/useDocumentsListService'

export const UpcomingPeriodicReviewSection: React.FC = () => {
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()
  const { loadPeriodicReview } = useDocumentsListService()

  const loadDataPeriodicDocs = () => {
    const defaultFilter = {
      pageSize: 5,
      pageStart: 0
    }
    return loadPeriodicReview(defaultFilter)
  }

  return (
    <>
      <h2 className="recent-docs">{translate('PERIODIC_REVIEW')}</h2>
      <RcmTableDataWrapper persistenceKey={'dashboardPeriodicReviewFiles'} loadData={loadDataPeriodicDocs}>
        <UpcomingPeriodicReviewTable />
      </RcmTableDataWrapper>
    </>
  )
}
